import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Category, Pagination } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends BaseApiService<Category> {
  get cacheKey(): StorageKey {
    return StorageKey.categoryServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    switch (operation) {
      case 'list':
        let regionId = params.regionId;
        if (regionId == null) {
          regionId = 'Brasil';
        }
        return `${environment.apiUrl}/regions/${encodeURIComponent(regionId)}/categories`;
      default:
        let url = `${environment.apiUrl}/categories`;
        if (id != null) {
          url = url + '/' + encodeURIComponent(id);
        }
        return url;
    }
  }

  list(params: {[params: string]: string}): Promise<Pagination<Category>> {
    return super.list(this.removeContractId(params));
  }

  protected unparse(obj) {
    return Category.unparse(obj);
  }

  protected parse(obj) {
    return Category.parse(obj);
  }

}
